import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-public-navbar',
  templateUrl: './public-navbar.component.html',
  styleUrls: ['./public-navbar.component.scss']
})
export class PublicNavbarComponent implements OnInit {
  user: any;
  extra = true;
  menuOpen = false;
  isCollapsed = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('clpUser'));
    this.extra = !localStorage.getItem('clpUser');
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isCollapsed = window.scrollY > 50;
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 992 && this.menuOpen) {
      this.menuOpen = false;
    }
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/account/login']).then(() => {
      window.location.reload();
    });
  }

  dashboard(): void {
    this.closeMenu();
    const user = JSON.parse(localStorage.getItem('clpUser'));
    const userType = user?.type;

    if (userType == 1) {
      this.router.navigate(['/buyer/marketplace']);
    } else {
      this.router.navigate(['/seller/contentlist']);
    }
  }
}
